import { z } from "zod";

import { OrderDirection } from "@/constants/orderDirection";

import { ColumnIds } from "./-constants";

export const SearchSchema = z.object({
  freeText: z.string().optional(),
  showDisabled: z.boolean().default(false),
  sortColumn: z
    .enum([
      ColumnIds.name,
      ColumnIds.specialtyCategoryName,
      ColumnIds.displayOrder,
    ])
    .optional(),
  sortOrder: z.nativeEnum(OrderDirection).optional(),
});
